import { OrbitControls, useGLTF, Html, useProgress } from '@react-three/drei';
import { Flex, Box, Image, Grid, Text, Spinner, useDisclosure } from '@chakra-ui/react';

const LoaderWithProgress = ({progress}) => {
  return (
    <Html center>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        bg="rgba(0,0,0,0)"
        p="0px"
        borderRadius="10px"
        textAlign="center"
        position="relative"
      >
        <Spinner color="rgba(255, 187, 24, 1)" w="60px" h="60px" style={{width: '60px', height: '60px'}} />
        <Box position="absolute" mt="9px" w="81%">
          <Text fontSize="9px" color="rgba(255, 187, 24, 1)" w="100%" fontWeight="bold">
            { Math.round(progress) }% 
          </Text>
          <Text position="absolute" mt="0px" fontSize="11px" color="rgba(255, 187, 24, 1)" w="100%" fontWeight="bold">
            loading ...
          </Text>
        </Box>
      </Box>
    </Html>
  );
};

export default LoaderWithProgress;